import React from 'react'
import { IconButton } from './IconButton'

const SPIN_STYLE = `@keyframes ekkam-refresh-spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`

interface RefreshButtonProps {
  onClick: () => void
  loading: boolean
  title?: string
  size?: number
  style?: React.CSSProperties
  className?: string
}

export const RefreshButton: React.FC<RefreshButtonProps> = ({
  onClick,
  loading,
  title = 'Refresh',
  size = 30,
  style,
  className,
}) => (
  <IconButton onClick={onClick} disabled={loading} title={title} size={size} style={style} className={className}>
    <style>{SPIN_STYLE}</style>
    <span style={{ display: 'inline-block', animation: loading ? 'ekkam-refresh-spin 0.8s linear infinite' : 'none' }}>
      ↺
    </span>
  </IconButton>
)
